const CSV_URL =
  'https://docs.google.com/spreadsheets/d/1FqUosXHG5XmquPUwzJpcCCVRMBCZsUHP/export?format=csv&gid=1976587560';

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

function getMesAtual() {
  const hoje = new Date();
  return `${MESES[hoje.getMonth()]}-${hoje.getFullYear()}`;
}

// Parser CSV que respeita campos entre aspas
function parseCSVLine(line) {
  const campos = [];
  let atual = '';
  let inQuote = false;

  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuote && line[i + 1] === '"') {
        atual += '"';
        i++;
      } else {
        inQuote = !inQuote;
      }
    } else if (ch === ',' && !inQuote) {
      campos.push(atual.trim());
      atual = '';
    } else {
      atual += ch;
    }
  }
  campos.push(atual.trim());
  return campos;
}

export async function buscarLivroDoMes() {
  const mesAtual = getMesAtual();

  // Limpar livroAtual se o mês mudou
  try {
    const livroAtual = JSON.parse(localStorage.getItem('livroAtual') || 'null');
    if (livroAtual && livroAtual.mes !== mesAtual) {
      localStorage.removeItem('livroAtual');
    }
  } catch {
    localStorage.removeItem('livroAtual');
  }

  try {
    console.log('[LivroDoMes] buscando CSV, mês:', mesAtual);
    const res = await fetch(CSV_URL, { cache: 'no-store' });
    console.log('[LivroDoMes] status HTTP:', res.status);
    if (!res.ok) throw new Error(`fetch failed: ${res.status}`);
    const csv = await res.text();
    console.log('[LivroDoMes] CSV recebido:', csv.slice(0, 200));

    const linhas = csv.split('\n').filter(l => l.trim());
    // Remove header
    const dados = linhas.slice(1);

    for (const linha of dados) {
      const partes = parseCSVLine(linha);
      const mes = partes[0]?.replace(/^"|"$/g, '').trim();
      console.log('[LivroDoMes] linha mês encontrado:', mes, '| esperado:', mesAtual);
      if (mes === mesAtual) {
        return {
          mes,
          titulo:     partes[1]?.replace(/^"|"$/g, '').trim() || '',
          autor:      partes[2]?.replace(/^"|"$/g, '').trim() || '',
          topico:     partes[3]?.replace(/^"|"$/g, '').trim() || '',
          sinopse:    partes[4]?.replace(/^"|"$/g, '').trim() || '',
          url_capa:   partes[5]?.replace(/^"|"$/g, '').trim() || '',
          link_amazon: partes[6]?.replace(/^"|"$/g, '').trim() || '',
        };
      }
    }
    console.log('[LivroDoMes] nenhum livro encontrado para o mês:', mesAtual);
    return null;
  } catch (err) {
    console.error('[LivroDoMes] erro no fetch:', err);
    return null;
  }
}

export function getStatusLivro(mes) {
  try {
    const livroAtual = JSON.parse(localStorage.getItem('livroAtual') || 'null');
    if (livroAtual?.mes === mes && livroAtual?.status === 'lendo') {
      return 'lendo';
    }

    const livrosConcluidos = JSON.parse(localStorage.getItem('livrosConcluidos') || '[]');
    if (livrosConcluidos.some(l => l.mes === mes)) {
      return 'concluido';
    }
  } catch {
    // ignorar erros de parse
  }
  return 'nao_iniciado';
}

export function iniciarLeitura(livro) {
  localStorage.setItem('livroAtual', JSON.stringify({
    mes: livro.mes,
    titulo: livro.titulo,
    status: 'lendo',
  }));
}

export function marcarComoLido(livro) {
  try {
    const livrosConcluidos = JSON.parse(localStorage.getItem('livrosConcluidos') || '[]');
    livrosConcluidos.push({
      mes: livro.mes,
      titulo: livro.titulo,
      dataConclusao: new Date().toISOString(),
    });
    localStorage.setItem('livrosConcluidos', JSON.stringify(livrosConcluidos));
    localStorage.removeItem('livroAtual');
  } catch {
    // ignorar
  }
}

export function getLivrosStats() {
  try {
    const livroAtual = JSON.parse(localStorage.getItem('livroAtual') || 'null');
    const livrosConcluidos = JSON.parse(localStorage.getItem('livrosConcluidos') || '[]');
    return {
      livrosIniciados: livroAtual ? 1 : 0,
      livrosConcluidos: livrosConcluidos.length,
    };
  } catch {
    return { livrosIniciados: 0, livrosConcluidos: 0 };
  }
}
